import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class MaterialEnterstoreItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialEnterstoreItem'
  }

}